import keyMirror from '../../utils/keyMirror';

export const NOTIF_ACTION_TYPES = keyMirror({
	CLEAN_STATE: null,
	ERROR: null,
	SUCCESS: null,
});
